"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _retailAddressChecker = require("@jsainsburyplc/retail-address-checker");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var AddressChecker = function AddressChecker(_ref) {
  var onChange = _ref.onChange,
      question = _ref.question,
      questionId = _ref.questionId,
      callback = _ref.callback;

  var _useState = (0, _react.useState)(false),
      showValErrors = _useState[0],
      setShowValErrors = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      isFormValid = _useState2[0],
      setIsFormValid = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      showNoAddressError = _useState3[0],
      setShowNoAddressError = _useState3[1];

  var _useState4 = (0, _react.useState)(false),
      isNoAddressGivenChecked = _useState4[0],
      setIsNoAddressGivenChecked = _useState4[1];

  var clearValidationErrors = function clearValidationErrors(showError) {
    setShowValErrors(showError);
  };

  var clearNoAddressError = function clearNoAddressError(showError) {
    setShowNoAddressError(showError);
  };

  var validateForm = function validateForm(isValid) {
    setIsFormValid(isValid);
  };

  var isAddressNotGivenChecked = function isAddressNotGivenChecked(checkBoxTicked) {
    setIsNoAddressGivenChecked(checkBoxTicked);
  };

  var handleOnChange = function handleOnChange(address) {
    setShowValErrors(!isFormValid);

    if (!question.isValid && !isNoAddressGivenChecked) {
      setShowNoAddressError(true);
    } else {
      setShowNoAddressError(false);
    }

    onChange(question, JSON.stringify(address), isFormValid || isNoAddressGivenChecked, callback);
  };

  return /*#__PURE__*/_react.default.createElement(_retailAddressChecker.AddressChecker, {
    key: questionId,
    getAddressData: function getAddressData(address) {
      return handleOnChange(address);
    },
    checkValidation: validateForm,
    showValidationErrors: showValErrors,
    clearValidationErrors: clearValidationErrors,
    isAddressNotGivenChecked: isAddressNotGivenChecked,
    showNoAddressError: showNoAddressError,
    clearNoAddressError: clearNoAddressError
  });
};

AddressChecker.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  question: _propTypes.default.object.isRequired,
  questionId: _propTypes.default.string.isRequired,
  callback: _propTypes.default.func
};
AddressChecker.defaultProps = {
  callback: function callback() {}
};
var _default = AddressChecker;
exports.default = _default;